export const contentPages = {
  contentPages: {
    searchPages: {
      noContent: 'No Pages with: <strong>"{{term}}"<strong>',
    },
    pageItem: {
      readMore: 'Read More >',
    },
  },
};
